<div class="center-small-container">
  @if(!isMobile) {
    <h1 class="page-title-center">User Settings</h1>
  } @else {
    <br />
  }

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline">
      <mat-label>Default Search Radius (Miles)</mat-label>

      <input
        matInput
        type="number"
        formControlName="default_search_radius_miles"
      />

      @if (form.get('default_search_radius_miles')?.hasError('required')) {
        <mat-error>Radius is required.</mat-error>
      }

      @if (
        form.get('default_search_radius_miles')?.hasError('min') ||
        form.get('default_search_radius_miles')?.hasError('max')
      ) {
        <mat-error>Radius must be between 50 and 500 miles.</mat-error>
      }
    </mat-form-field>

    @if (carriers.length > 0) {
      <mat-form-field appearance="outline">
        <mat-label>Default Carrier</mat-label>

        <mat-select formControlName="default_carrier_id">
          @for (carrier of carriers; track carrier.id) {
            <mat-option [value]="carrier.id">
              {{ carrier.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (brokers.length > 0) {
      <mat-form-field appearance="outline">
        <mat-label>Default Broker</mat-label>

        <mat-select formControlName="default_broker_id">
          @for (broker of brokers; track broker.id) {
            <mat-option [value]="broker.id">
              {{ broker.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <button mat-button class="lightgreen-button" type="submit" [disabled]="loading()">
      Save
    </button>
  </form>

  <mat-divider></mat-divider>

  <div class="section-header">
    <h1 class="page-subtitle ml-5">API Keys</h1>

    <div class="api-action-buttons">

      <button
        mat-icon-button
        matTooltip="API Documentation"
        (click)="openApiDocumentation()"
      >
        <mat-icon>help_outline</mat-icon>
      </button>

      <button
        mat-icon-button
        matTooltip="Refresh API keys"
        (click)="refreshApiKeys()"
        [disabled]="loading()" 
      >
        <mat-icon>refresh</mat-icon>
      </button>

      <button
        mat-icon-button
        matTooltip="Create API key"
        (click)="openCreateApiKeyDialog()"
        [disabled]="loading()" 
      >
        <mat-icon>add_circle_outline</mat-icon>
      </button>
    </div>
    
  </div>

  @if (apiKeys().length > 0) {
    <div class="grey-container">
      Today API Usage: {{ apiTodayUsage() }} / {{ apiDailyLimit() }}
      @if (apiTodayUsage() >= apiDailyLimit() && apiTodayUsage() > 0) {
        <span class="tag red ml-5">limit reached</span>
      }
    </div>
  }

  <div class="api-key-list">
    @for (apiKey of apiKeys(); track apiKey.id) {
      <div class="grey-container api-key-card">
        <div class="api-key-info">
          <div class="api-key-name">
            {{ apiKey.name }}
          </div>

          <div class="api-key-meta">
            @if (apiKey.last_used_since) {
              Last used {{ apiKey.last_used_since }}
            } @else {
              Never used
            }
          </div>
        </div>

        <button
          mat-icon-button
          matTooltip="Delete API key"
          class="danger-button"
          (click)="deleteApiKey(apiKey)"
          [disabled]="loading()" 
        >
          <mat-icon>close</mat-icon>
        </button>

      </div>
    } @empty {
      @if (!loading()) {
        <div class="yellow-container text-center">
          You don't have any keys yet.
        </div>
      }
    }
  </div>
</div>